module.exports = __webpack_public_path__ + "static/media/signage-indoor-img29.c0fa0560.jpg";